import { bus } from '@core/events/eventSystem';
import constants from '@core/utils/constants';
import { userMigration } from './userMigration';

// lancer la migration des données legacy quand l'app est prête
bus.on(constants.EVENTS.APP.READY, () => {
  console.log('[UserMigration] App ready, lancement de la détection de migration...');
  userMigration.migrateUser();
});
